import { useEffect, useMemo } from 'react'

import moment from 'moment'

import { dateToString } from 'modules/core/lib/dates'

import DocumentForm from 'modules/timeoff/lib/DocumentForm'
import LeaveForm from 'modules/timeoff/lib/LeaveForm'
import type LeaveType from 'modules/timeoff/store/models/LeaveType'

interface FormProps {
  leaveEmployeeId?: string
  leaveYear?: string | null | undefined
  selectedLeaveType: LeaveType | null | undefined
  startDate?: string | undefined
  endDate?: string | undefined
}
interface ReturnType {
  form: LeaveForm
  documentForm: DocumentForm
  year: number
}

const useForms = ({
  leaveEmployeeId,
  leaveYear,
  selectedLeaveType,
  startDate,
  endDate,
}: FormProps): ReturnType => {
  const documentForm = useMemo(() => new DocumentForm({}), [])

  const date = useMemo(() => {
    const today = moment()
    const start = startDate ? moment(startDate) : today

    return leaveYear ? today.year(+leaveYear) : start
  }, [leaveYear, startDate])

  const form = useMemo(() => {
    const startOn = dateToString(date, 'backend')
    const finishOn = endDate ? dateToString(moment(endDate), 'backend') : startOn

    return new LeaveForm({
      employee_id: leaveEmployeeId,
      start_on: startOn,
      finish_on: finishOn,
    })
  }, [date, leaveEmployeeId, endDate])

  useEffect(() => {
    form.setValues({
      leave_type_id: selectedLeaveType?.attributes.id,
    })
  }, [form, selectedLeaveType])

  return {
    form,
    documentForm,
    year: date.year(),
  }
}

export default useForms
